import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function ExchangePost() {
  const navigate = useNavigate();
  const [meta, setMeta] = useState({ categories: [], sizes: [], types: [] });
  const [form, setForm] = useState({
    title: "", headline: "", body: "",
    category: "ma", type: "Selling", size: "$1M+", region: "North America",
    deal_value_m: 5,
    posted_by_name: "", posted_by_email: "", posted_by_company: "",
  });

  useEffect(() => { api.get("/exchange/categories").then(r => setMeta(r.data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (form.deal_value_m < 1) { toast.error("Minimum deal value is $1M."); return; }
    try {
      const { data } = await api.post("/exchange/listings", form);
      toast.success("Listing posted.");
      navigate(`/exchange/listing/${data.id}`);
    } catch { toast.error("Could not post."); }
  };

  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16" data-testid="exchange-post">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Post a Deal</div>
      <h1 className="display-black text-4xl lg:text-5xl uppercase text-[#064E3B] mt-3 tracking-tighter">List on the Exchange.</h1>
      <p className="text-gray-700 mt-2">$1M floor. Premium members only. Be precise — vague posts get ignored.</p>

      <form onSubmit={submit} className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 border border-gray-300 p-8" data-testid="post-form">
        <input className="input-federal md:col-span-2" required placeholder="Deal title" value={form.title} onChange={e => setForm({...form, title: e.target.value})} data-testid="post-title" />
        <input className="input-federal md:col-span-2" required placeholder="One-line headline (numbers, geography)" value={form.headline} onChange={e => setForm({...form, headline: e.target.value})} data-testid="post-headline" />
        <textarea className="input-federal md:col-span-2" rows={6} required placeholder="Full description — buyer profile, deal mechanics, timeline" value={form.body} onChange={e => setForm({...form, body: e.target.value})} data-testid="post-body" />

        <select className="input-federal" value={form.category} onChange={e => setForm({...form, category: e.target.value})} data-testid="post-category">
          {meta.categories.map(c => <option key={c.slug} value={c.slug}>{c.name}</option>)}
        </select>
        <select className="input-federal" value={form.type} onChange={e => setForm({...form, type: e.target.value})} data-testid="post-type">
          {meta.types.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
        <select className="input-federal" value={form.size} onChange={e => setForm({...form, size: e.target.value})} data-testid="post-size">
          {meta.sizes.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <select className="input-federal" value={form.region} onChange={e => setForm({...form, region: e.target.value})} data-testid="post-region">
          {["North America", "South America", "Europe", "Middle East", "Asia", "Africa", "Oceania", "Global"].map(r => <option key={r} value={r}>{r}</option>)}
        </select>
        <input className="input-federal md:col-span-2" required type="number" min={1} step="0.5" placeholder="Deal value in $M (min 1)" value={form.deal_value_m} onChange={e => setForm({...form, deal_value_m: parseFloat(e.target.value) || 0})} data-testid="post-value" />

        <div className="md:col-span-2 border-t border-gray-200 pt-5">
          <div className="mono text-[10px] tracking-[0.22em] uppercase text-[#D97706]">// Your contact</div>
        </div>
        <input className="input-federal" required placeholder="Your name" value={form.posted_by_name} onChange={e => setForm({...form, posted_by_name: e.target.value})} data-testid="post-name" />
        <input className="input-federal" required type="email" placeholder="Email" value={form.posted_by_email} onChange={e => setForm({...form, posted_by_email: e.target.value})} data-testid="post-email" />
        <input className="input-federal md:col-span-2" placeholder="Company / Firm" value={form.posted_by_company} onChange={e => setForm({...form, posted_by_company: e.target.value})} data-testid="post-company" />

        <button type="submit" className="btn-signal md:col-span-2 justify-center" data-testid="post-submit">Publish to Exchange <ArrowRight className="w-4 h-4" /></button>
      </form>
    </div>
  );
}
